import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import Img from "gatsby-image";

import "./BusinessSolutionHeroBanner.css";

const BusinessSolutionHeroBanner = () => {
    const data = useStaticQuery(graphql`
        query BuesinessSolnHeroBannerQuery {
            mobileImage: file(relativePath: { eq: "bs-hero-mob-1x_v5.png" }) {
                childImageSharp {
                    fluid {
                        aspectRatio
                        base64
                        srcSet
                    }
                }
            }

            desktopImage: file(relativePath: { eq: "bs-hero-web-1x_v4.png" }) {
                childImageSharp {
                    fluid {
                        aspectRatio
                        base64
                        srcSet
                    }
                }
            }
        }
    `);

    const sources = [
        data.desktopImage.childImageSharp.fluid,
        {
            ...data.mobileImage.childImageSharp.fluid,
            media: `(max-width: 600px)`,
        },
    ];

    return (
        <div className="bussol-herobanner">
            <div className="bussol-herobanner__content">
                <h2>
                    Grow your business <br /> with PhonePe
                </h2>
                <p>
                    We can help you achieve <br />
                    your business goals.
                </p>
            </div>
            <div className="bussol-herobanner__img">
                <Img
                    fluid={sources}
                    imgStyle={{
                        objectFit: "contain",
                        height: "100%",
                        objectPosition: "center right",
                    }}
                    alt="PhonePe Business Solutions"
                />
            </div>
        </div>
    );
};

export default BusinessSolutionHeroBanner;
